import { ModuleWithProviders, NgModule } from '@angular/core';
import { EnvironmentSettingsService } from './environment-settings.service';
import { FeatureFlagsService } from './featureFlags.service';

@NgModule()
export class SharedServicesModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SharedServicesModule,
      providers: [
        EnvironmentSettingsService,
        FeatureFlagsService
      ] // Add services you want to be singleton here
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/shared-services/shared-services.module.ts